/**
 * Recurring Job board row-open and full-page route for the Surface Engine surfaces.
 *
 * Deliberately separate from the legacy `/jobs/recurring` board, which stays on its own dashboard
 * and its own manage page until the Manage surface carries Schedules, Items and Tasks.
 */
import { inject, Injector } from '@angular/core';
import { ActivityEntityName, RecurringJob } from '@jms/model';
import { EntityInspectors } from '@workbuddy/ui/v2/blocks/entity.inspector';
import { entityRecordUrl } from '@workbuddy/ui/v2/blocks/entity.record';

export const RECURRING_JOB_SLUG = 'recurring-job';

/**
 * System view "All Recurring Jobs". Composed from the same enum the server composes it from
 * (`recurring.job.system.views.ts`), so renaming the entity cannot silently unlink the two. The UUID
 * suffix stays: per-user column and display preferences are stored against the view id.
 */
export const RECURRING_JOB_ALL_VIEW_ID = `${ActivityEntityName.RecurringJob}-83dc2cda-7a48-4e29-a6a4-eceb2444b0fd`;

export function recurringJobRecordRoute(id: string): string {

  return entityRecordUrl(RECURRING_JOB_SLUG, 'edit', id)!;
}

export async function navigateToRecurringJobManage(item: RecurringJob): Promise<void> {

  if (!item?._id) return;
  const injector = inject(Injector);

  await injector.get(EntityInspectors).open({
    operation: 'edit',
    entity: ActivityEntityName.RecurringJob,
    id: item._id,
  });
}
